import React, { useState } from 'react';
import { Copy } from 'phosphor-react';
import { CopyToClipboard } from 'react-copy-to-clipboard';

function CopyToClipboardButton({ text }: { text: string }): JSX.Element {
  const [isCopied, setIsCopied] = useState(false);

  const handleCopy = (event: React.MouseEvent): void => {
    void (async () => {
      event.preventDefault();
      setIsCopied(true);
      setTimeout(() => {
        setIsCopied(false);
      }, 1000);
    })();
  };
  return (
    <>
      <div className="float-right align-middle text-gray-800 cursor-pointer inline">
        <CopyToClipboard text={text} data-testid="copy-button">
          <Copy onClick={handleCopy} size="1.1rem" weight="bold" />
        </CopyToClipboard>
      </div>
      {isCopied ? <div className="absolute -bottom-0 right-1 text-blue-500">Copied</div> : null}
    </>
  );
}

export default CopyToClipboardButton;
